'use strict';

angular.module('app.entity.field.audit', [
    'app.entity.audit',
    'app.entity.service',
])
.component('fieldAudit', {
    templateUrl: 'modules/ecrd/components/field/audit/content.html',
    controller: 'FieldAuditController',
    bindings: {
        fieldId: '<',
        // La versión actual de la entidad. Cuando cambie toca recargar el audit
        entityVersion: '<',
    },
});
